import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, withStateHandlers } from 'recompose'

import { isEqual, getPaginationObject } from 'utils/misc'

import * as groupModule from 'modules/group'
import * as peopleModule from 'modules/people'

export default compose(
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.people.selected),
        groups: idx(state, _ => _.groups.userItems),
        tableLoading: idx(state, _ => _.groups.loading),
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...groupModule,
        ...peopleModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      filters: {
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onGroupItemSelect: ({ 
      actions, organisation, user, filters, setPagination
    }) => (selectedGroup) => {
      actions.deleteUserFromGroup(organisation, selectedGroup, user, () => {
        actions.getUserGroups(user, organisation, filters, setPagination)
      })
    }
  }),
  lifecycle({
    componentDidMount() {
      const {
        actions, user, organisation, filters, setPagination
      } = this.props
      if (user && organisation) {
        actions.getUserGroups(user, organisation, filters, setPagination)
      }
    },
    componentDidUpdate(prevProps) {
      const {
        actions, user, organisation, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getUserGroups(user, organisation, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/components/organisms/UserGroups/UserGroups.enhancer.js